module.exports = __webpack_public_path__ + "img/qyfw.1d953df6.png";